export default {
    welcome: $localize `Welcome discount`,
    referral: $localize `Referral discount`,
    discount: $localize `Discount`,
}